<template>
  <div class="page">
    <!-- 导航栏 -->
    <div class="page_head">
      <div class="menu_btn" @click="toggleMenu">
        <span :class="{ active: isMenuOpen }"></span>
        <span :class="{ active: isMenuOpen }"></span>
        <span :class="{ active: isMenuOpen }"></span>
      </div>
      <ul class="nav" :class="{ show: isMenuOpen }">
        <li v-for="(item, index) in navItems" :key="index" :class="{ title: true, active: activeIndex === index }" @click="setActive(index)">
          {{ item }}
        </li>
      </ul>
    </div>

    <!-- 首页头部 -->
    <HomeHeader @setActive="setActive" />
    <!-- 最新动态 -->
    <WhatsNew />
    <!-- 概述部分 -->
    <Overview />
    <!-- 排行榜(短片段) -->
    <LeaderboardShort />
    <!-- 排行榜(中片段) -->
    <LeaderboardMedium />
    <!-- 排行榜(长片段) -->
    <LeaderboardLong />
    <!-- 评估部分 -->
    <Evaluation />
    <!-- 示例部分 -->
    <Examples />

    <!-- 联系信息 -->
    <div class="contact_info" id="contact">
      <div class="information">{{ information }}</div>
      <div class="mail">{{ mail }}</div>
    </div>

    <!-- 页脚 -->
    <div class="page_footer">
      <div class="footer">Copyright &copy; LaViLab & PhoenixTV</div>
    </div>
  </div>
</template>

<script>
// 导入所有拆分的组件
import HomeHeader from "../components/mobileComponent/HomeHeader.vue";
import WhatsNew from "../components/mobileComponent/WhatsNew.vue";
import Overview from "./mobileComponent/OverviewSection.vue";
import LeaderboardShort from "../components/mobileComponent/LeaderboardShort.vue";
import LeaderboardMedium from "../components/mobileComponent/LeaderboardMedium.vue";
import LeaderboardLong from "../components/mobileComponent/LeaderboardLong.vue";
import Evaluation from "./mobileComponent/EvaluationSection.vue";
import Examples from "../components/mobileComponent/ExampleList.vue";

export default {
  name: "H5Component",
  components: {
    HomeHeader,
    WhatsNew,
    Overview,
    LeaderboardShort,
    LeaderboardMedium,
    LeaderboardLong,
    Evaluation,
    Examples,
  },
  data() {
    return {
      isMenuOpen: false,
      activeIndex: 0,
      navItems: ["Home", "What's New", "Overview", "Leaderboards", "Evaluation", "Examples", "Contact"],
      information: "Contact Information",
      mail: "Contact us: lavilabcuhk@gmail.com",
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    setActive(index) {
      this.activeIndex = index;
      this.isMenuOpen = false;

      const sections = ["home", "whats-new", "overview", "leaderboards", "evaluation", "nemobench-examples", "contact"];
      const sectionId = sections[index];
      const element = document.getElementById(sectionId);

      if (element) {
        const offset = 64;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 768) {
        this.isMenuOpen = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
// 仅保留导航栏、联系信息和页脚样式
$mobile: 768px;
$tablet: 1024px;

.page {
  background-color: rgba(10, 14, 22, 1);
  position: relative;
  width: 100%;
  padding-top: 64px;

  .page_head {
    width: 100%;
    height: 64px;
    position: fixed;
    top: 0;
    background: rgba(10, 14, 22, 1);
    z-index: 1000;
    border-bottom: 1px solid rgba(255, 255, 255, 0.13);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 15px;

    .menu_btn {
      display: none;
      flex-direction: column;
      justify-content: space-around;
      width: 30px;
      height: 24px;
      cursor: pointer;
      z-index: 1001;

      span {
        width: 100%;
        height: 3px;
        background-color: #fff;
        border-radius: 3px;
        transition: all 0.3s ease;
        transform-origin: center;
      }

      span.active:nth-child(1) {
        transform: translateY(9px) rotate(45deg);
      }

      span.active:nth-child(2) {
        opacity: 0;
      }

      span.active:nth-child(3) {
        transform: translateY(-9px) rotate(-45deg);
      }
    }

    .nav {
      display: flex;
      align-items: center;

      .title {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        margin-left: 33px;
        cursor: pointer;

        &.active {
          color: rgba(255, 255, 255, 1);
          font-family: PingFangSC-Semibold;
        }
      }
    }

    @media (max-width: $mobile) {
      .menu_btn {
        display: flex;
      }

      .nav {
        position: fixed;
        top: 64px;
        left: 0;
        width: 100%;
        height: calc(100vh - 64px);
        background-color: rgba(10, 14, 22, 0.98);
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
        margin: 0;
        padding: 0;

        &.show {
          transform: translateX(0);
        }

        .title {
          margin: 15px 0;
          font-size: 18px;
        }
      }
    }

    @media (min-width: ($mobile + 1)) and (max-width: $tablet) {
      & {
        justify-content: center;
      }
      .nav .title {
        margin-left: 12px;
        font-size: 14px;
      }
    }
  }

  .contact_info {
    background: url("../assets/images/Background3.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    padding: 40px 15px;
    text-align: center;

    .information {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 62px;
      text-align: center;
      font-style: normal;
    }

    .mail {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ff621f;
      line-height: 53px;
      text-align: center;
      font-style: normal;
      word-break: break-all;
    }

    @media (max-width: $mobile) {
      .information {
        font-size: 24px;
        margin-bottom: 15px;
      }

      .mail {
        font-size: 18px;
      }
    }

    @media (min-width: ($mobile + 1)) and (max-width: $tablet) {
      .information {
        font-size: 30px;
        margin-bottom: 20px;
      }

      .mail {
        font-size: 24px;
      }
    }
  }

  .page_footer {
    .footer {
      border-top: 1px solid rgba(255, 255, 255, 0.13);
      height: 60px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: AppleColorEmoji;
      font-size: 14px;
      color: #dedede;
      line-height: 28px;
      text-align: center;
      font-style: normal;
      padding: 0 15px;
    }
  }
}
</style>
